import { ScriptAddTxParams, FundAddScriptsTxParams, ProtocolAddScriptsTxParams, toJson, WalletTxParams } from '../../Commons';
import { ScriptEntity } from '../../Entities/Script.Entity';
import { fetchWrapper } from '../../lib/index.exports';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';

export class ScriptTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = ScriptEntity;

    // #region api tx

    public static async addProtocolScriptTxApi(walletTxParams: WalletTxParams, txParams: ProtocolAddScriptsTxParams & ScriptAddTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `ProtocolAddScriptsTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/addProtocolScript`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - addProtocolScriptTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - addProtocolScriptTxApi - Error: ${error}`);
            throw error
        }
    }

    public static async addFundScriptTxApi(walletTxParams: WalletTxParams, txParams: FundAddScriptsTxParams & ScriptAddTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `FundAddScriptsTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/addFundScript`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - addFundScriptTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - addFundScriptTxApi - Error: ${error}`);
            throw error
        }
    }

    // #endregion api tx
}
